module.exports = __webpack_public_path__ + "img/caller.aa766353.jpg";